export const veniceSetup = () => {
  localStorage.setItem('currency', 'EUR');
};
